import styled from 'styled-components';
import Inner from '../components/Inner';
import PageTitle from '../components/PageTitle';
import { useAppSelector } from '../hooks/useRedux';
import { User } from '../store/usersSlice';
import goods from '../mock/goods.json';
import CartProduct from '../components/CartProductCard';
import { styled as muiStyled } from '@mui/system';
import Button from '@mui/material/Button/Button';
import Swal from 'sweetalert2';

const ProductWrapper = styled.div`
	margin-top: 7rem;

	@media (max-width: 767px) {
		margin-top: 4rem;
	}

	@media (min-width: 768px) and (max-width: 1023px) {
		margin-top: 5rem;
	}
`;

const OrderWrapper = styled.div`
	margin: 7rem 0 6rem;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 1.6rem;

	@media (max-width: 767px) {
		margin: 4rem 0;
	}

	@media (min-width: 768px) and (max-width: 1023px) {
		margin: 5rem 0;
	}
`;

const OrderButton = muiStyled(Button)({
	fontSize: '2rem',
	fontWeight: '700',
	padding: '0.6rem 3rem',
	marginBottom: '7rem',

	'@media (max-width:767px)': {
		fontSize: '1.2rem',
		padding: '0.4rem 2rem',
		marginBottom: '4rem',
	},

	'@media (min-width:768px) and (max-width:1023px)': {
		marginBottom: '5rem',
	},
});

const NoProduct = styled.div`
	display: flex;
	justify-content: center;
	font-size: 2.4rem;
	color: #adb5bd;
	margin-top: 7rem;

	@media (max-width: 767px) {
		font-size: 1rem;
		margin-top: 4rem;
	}

	@media (min-width: 768px) and (max-width: 1023px) {
		font-size: 2rem;
		margin-top: 6rem;
	}
`;

function Cart() {
	const user = useAppSelector((state) => state.auth.user) as User;
	const cartProductsId = user.cart;

	// 방법 1. goods의 id 순서대로 - some()
	// const cart = goods.filter((e) => {
	//   return cartProductsId?.some((cartProductId) => cartProductId.productId === e.id);
	// });

	// 방법 2. 장바구니에 추가한 순서대로 - find()
	const cartList = (cartProductsId || [])
		.map((productId) => {
			return goods.find((e) => e.id === productId.productId);
		})
		// 타입 오류 방지를 위해 undefined 제거
		.filter((product): product is (typeof goods)[number] => product !== undefined);

	const handleOrderButton = () => {
		Swal.fire({
			title: '구매가 완료되었습니다.',
			confirmButtonText: '확인',
			confirmButtonColor: '#0E1B4E',
			customClass: {
				popup: 'swal-popup',
				title: 'swal-title',
				confirmButton: 'swal-confirm-button',
			},
			scrollbarPadding: false,
		});
	};

	return (
		<Inner>
			<PageTitle korean>장바구니</PageTitle>
			{cartList.length > 0 ? (
				<>
					<ProductWrapper>
						{cartList.map((product) => (
							<CartProduct
								key={product.id}
								id={product.id}
								img={product.img}
								title={product.title}
								artist={product.artist}
								price={product.price}
							/>
						))}
					</ProductWrapper>
					<OrderWrapper>
						<OrderButton type='submit' variant='contained' onClick={handleOrderButton}>
							주문하기
						</OrderButton>
					</OrderWrapper>
				</>
			) : (
				<NoProduct>장바구니에 담긴 상품이 존재하지 않습니다.</NoProduct>
			)}
		</Inner>
	);
}

export default Cart;
